import { getReference } from "@luciad/ria/reference/ReferenceProvider";
import { Bounds } from "@luciad/ria/shape/Bounds";
import { createBounds } from "@luciad/ria/shape/ShapeFactory";


export class OGCAPIMapsCapabilitiesLayer {

  _id: string = "";
  _title: string = "";
  _url: string = "";
  _bboxCrs: string = "";
  _bounds: Bounds = createBounds(getReference("CRS:84"), [0, 0, 0, 0]);
  _useVectorTiles: boolean = false;

  constructor(id: string, title: string, url: string, bounds: Bounds, bboxCrs: string) {
    this._id = id;
    this._title = title;
    this._url = url;
    this._bounds = bounds;
    this._bboxCrs = bboxCrs;
  };

  get useVectorTiles(): boolean {
    return this._useVectorTiles;
  };

  get bboxCrs(): string {
    return this._url;
  };

  get url(): string {
    return this._url;
  };

  get name(): string {
    return this._id;
  };

  get title(): string {
    return this._title;
  };

  get bounds(): Bounds {
    return this._bounds;
  };

  get children(): OGCAPIMapsCapabilitiesLayer[] {
    return [];
  }

  get styles(): any[] {
    return [];
  }
}